import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicSummary = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="SUMMARY"
      videos={[]} // No videos for summary
      takeaways={[
        { text: "You may get total of three questions from this module for CAT-1" },
        { text: "If you are unable to completely solve the problem just remember how to solve the problem through various methods and write the overall process of solving the problem" },
        { text: "one question from solving DE in Mechanical and Electrical Circuits" },
        { text: "one question from method of undetermined coefficients" },
        { text: "remaining question from either method of variation of parameters or Cauchy-Euler's type" },
      ]}
      questions={[]} // Empty questions
      exampleVideos={[]} // Empty example videos
    />
);
}

export default ModuleSubtopicSummary;